export class FormElementSocialMediaType {
  // #region Properties

  public SocialMediaTypeId: number;
  public Name: string;
  public LabelText: string;
  public HelpText: string;
  public Visible: boolean;
  public Value: string;

  // #endregion

  public constructor() {
    this.SocialMediaTypeId = 0;
    this.Name = '';
    this.LabelText = '';
    this.HelpText = '';
    this.Visible = false;
    this.Value = '';
  }
}
